export default {
  common: {
    confirm: '确定',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    search: '搜索',
    reset: '重置',
    loading: '加载中...',
    loadMore: '加载更多',
    back: '返回',
    edit: '编辑',
    preview: '预览',
    publish: '发布',
    off: '下线',
    official: '官方',
    anonymous: '匿名',
    share: '分享',
    report: '举报',
    viewAll: '查看全部',
    retry: '点击重试',
    operationFailed: '操作失败',
    unknownError: '未知错误',
    loginSuccess: '登录成功',
    logoutSuccess: '已退出登录',
    createSuccess: '创建成功',
    saveSuccess: '保存成功',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    loadFailed: '加载失败',
    comingSoon: '功能开发中',
    notice: '提示',
    requestFailed: '请求失败',
    unauthorized: '未登录或登录已过期，请重新登录',
    forbidden: '您没有权限执行此操作',
    resourceNotFound: '资源不存在',
    serverError: '服务器错误',
    networkError: '网络异常，请检查网络连接'
  },
  router: {
    siteName: '汉字社区',
    login: '登录',
    home: '首页',
    character: '汉字详情',
    note: '笔记详情',
    publish: '发布笔记',
    topics: '话题广场',
    topic: '话题详情',
    search: '搜索',
    profile: '个人主页',
    wallet: '我的汉币',
    words: '生词本',
    adminLogin: '管理登录',
    dashboard: '控制台',
    users: '用户管理',
    roles: '角色管理',
    permissions: '权限管理',
    texts: '内容管理',
    settings: '系统设置'
  },
  permission: {
    SUPER_ADMIN: '超级管理员',
    ADMIN: '管理员',
    MODERATOR: '版主',
    USER: '用户',
    unknown: '未知'
  },
  time: {
    justNow: '刚刚',
    minutesAgo: '{n}分钟前',
    hoursAgo: '{n}小时前'
  },
  frontLayout: {
    searchPlaceholder: '搜索汉字、笔记、话题...',
    publish: '发布',
    user: '用户',
    profile: '个人主页',
    wallet: '我的汉币',
    words: '生词本',
    topics: '话题广场',
    logout: '退出登录',
    login: '登录',
    home: '首页',
    topic: '话题',
    searchNav: '搜索',
    mine: '我的',
    logoutConfirm: '确定要退出登录吗？',
    logoutConfirmTitle: '提示'
  },
  frontLogin: {
    logoChar: '字',
    tagline: '探索汉字之美',
    subtitle: '分享文化之韵，记录学习历程',
    featureStoryTitle: '汉字故事分享',
    featureStoryDesc: '用笔记记录每个汉字背后的文化与故事',
    featureOriginTitle: '字源探索研究',
    featureOriginDesc: '从甲骨文到现代汉字，追溯字源演变',
    featureCommunityTitle: '社区互动交流',
    featureCommunityDesc: '与同好交流心得，共同进步',
    copyright: '汉字社区 © 2026',
    welcomeBack: '欢迎回来',
    createAccount: '创建账户',
    loginSubtitle: '登录您的账户以继续探索汉字之美',
    registerSubtitle: '填写信息创建新账户，开始您的汉字之旅',
    login: '登录',
    register: '注册',
    usernamePlaceholder: '用户名/邮箱',
    passwordPlaceholder: '密码',
    emailPlaceholder: '邮箱',
    confirmPasswordPlaceholder: '确认密码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    contactAdminReset: '请联系管理员重置密码',
    noAccount: '还没有账号？',
    registerNow: '立即注册',
    hasAccount: '已有账号？',
    loginNow: '立即登录',
    thirdPartyLogin: '第三方账号登录',
    passwordMismatch: '两次输入的密码不一致',
    enterUsernameOrEmail: '请输入用户名或邮箱',
    enterPassword: '请输入密码',
    passwordMin: '密码长度至少8位',
    enterUsername: '请输入用户名',
    usernameLength: '用户名长度为3-20个字符',
    enterEmail: '请输入邮箱',
    validEmail: '请输入正确的邮箱',
    confirmPassword: '请确认密码',
    googleLoginSuccess: 'Google 登录成功',
    registerSuccess: '注册成功，请登录',
    loginFailed: '登录失败',
    registerFailed: '注册失败'
  },
  home: {
    recommend: '推荐',
    following: '关注',
    hotTopics: '热门话题',
    emptyTitle: '暂无内容',
    emptyDesc: '还没有相关的笔记，快去发布第一条内容吧',
    publishNote: '发布笔记',
    loadFailedTitle: '加载失败',
    loadFailedDesc: '内容加载出了点问题，请稍后重试',
    reload: '重新加载',
    loadMore: '加载更多',
    loading: '加载中...',
    feedEnd: '已经到底啦~',
    todayCharacter: '今日汉字',
    officialPick: '官方精选',
    noIntro: '暂无介绍',
    strokeCount: '笔画数',
    radical: '部首',
    meaning: '释义',
    viewDetail: '查看详情',
    shareStory: '我也来讲故事',
    quickActions: '快速操作',
    browseTopics: '浏览话题',
    searchCharacter: '搜索汉字',
    trendingTopics: '热门话题',
    topicsLoadFailed: '话题加载失败',
    noTrendingTopics: '暂无热门话题',
    notes: '笔记'
  },
  search: {
    title: '搜索',
    placeholder: '输入汉字、拼音或部首笔画进行搜索',
    handwritingInput: '手写输入',
    radicalStrokes: '部首笔画',
    characters: '汉字',
    notes: '笔记',
    topics: '话题',
    noCharacters: '没有找到相关汉字',
    noNotes: '没有找到相关笔记',
    noTopics: '没有找到相关话题',
    handwritingTitle: '手写输入',
    clear: '清空',
    recognize: '识别',
    radicalSearchTitle: '部首笔画搜索',
    radical: '部首',
    selectRadical: '选择部首',
    remainingStrokes: '剩余笔画',
    handwritingDev: '手写识别功能开发中',
    radicalDev: '部首笔画搜索功能开发中',
    searchFailed: '搜索失败，请稍后重试',
    notesCount: '笔记',
    followersCount: '关注'
  },
  topics: {
    title: '话题广场',
    hot: '热门话题',
    new: '最新话题',
    official: '官方推荐',
    officialBadge: '官方',
    searchPlaceholder: '搜索话题...',
    createTopic: '创建话题',
    notes: '笔记',
    followers: '关注',
    loadMore: '加载更多',
    createTitle: '创建新话题',
    nameLabel: '话题名称',
    namePlaceholder: '输入话题名称，如：汉字故事',
    descLabel: '话题描述',
    descPlaceholder: '简单描述这个话题的内容...',
    iconLabel: '话题图标',
    submit: '提交申请',
    enterName: '请输入话题名称',
    nameLength: '话题名称长度为2-20个字符',
    enterDesc: '请输入话题描述',
    descLength: '描述长度为10-100个字符',
    loadFailed: '加载话题失败',
    avatarFormat: '头像图片只能是 JPG/PNG 格式!',
    avatarSize: '头像图片大小不能超过 2MB!',
    createSuccess: '话题创建成功',
    createFailed: '话题创建失败'
  },
  wallet: {
    title: '我的汉币',
    balanceLabel: '我的汉币余额',
    coinUnit: '枚',
    dailyCheckin: '每日签到',
    recharge: '充值',
    getCoins: '获取汉币',
    earnTitle: '获取汉币',
    checkinTitle: '每日签到',
    checkinDesc: '1～5 枚汉币',
    publishTitle: '发布笔记',
    publishDesc: '成功发布一篇笔记 +5 枚',
    likeTitle: '获得点赞',
    likeDesc: '笔记每被点赞 +1 枚',
    collectTitle: '获得收藏',
    collectDesc: '笔记每被收藏 +3 枚',
    featuredTitle: '官方加精',
    featuredDesc: '笔记被官方加精 +50 枚',
    rechargeTitle: '汉币充值',
    coinsAmount: '{n} 枚汉币',
    rechargeNow: '立即充值',
    historyTitle: '汉币流水记录',
    noTransactions: '暂无汉币流水记录',
    loadFailed: '加载钱包信息失败',
    checkinSuccess: '签到成功 +{n} 汉币',
    checkinFailed: '签到失败',
    rechargeDev: '充值功能开发中',
    txSignin: '每日签到',
    txPublish: '发布笔记',
    txLike: '收到点赞',
    txCollect: '收到收藏',
    txFeatured: '笔记加精',
    txRewardGiven: '打赏支出',
    txRewardReceived: '收到打赏',
    txOther: '汉币变动'
  },
  topicDetail: {
    official: '官方',
    notes: '笔记',
    followers: '关注',
    following: '已关注',
    followTopic: '关注话题',
    hot: '最热',
    new: '最新',
    loadTopicFailed: '加载话题详情失败',
    loadNotesFailed: '加载笔记失败',
    followSuccess: '关注成功',
    unfollowSuccess: '已取消关注',
    share: '分享',
    loadMore: '加载更多'
  },
  noteDetail: {
    back: '返回',
    views: '{n} 次浏览',
    follow: '关注',
    following: '已关注',
    share: '分享',
    report: '举报',
    supportAuthor: '支持作者',
    myCoins: '我的汉币: {n} 枚',
    coins: '枚汉币',
    reward: '打赏',
    comments: '全部评论 ({n})',
    commentPlaceholder: '写下你的评论...',
    submitComment: '发表评论',
    reply: '回复',
    replyPlaceholder: '写下你的回复...',
    reportTitle: '举报内容',
    reasonLabel: '举报原因',
    selectReason: '请选择举报原因',
    reasonSpam: '广告或垃圾信息',
    reasonFake: '不实信息',
    reasonIllegal: '违法违规',
    reasonAbuse: '辱骂攻击',
    reasonOther: '其他',
    detailLabel: '详细说明',
    detailPlaceholder: '请详细说明举报原因',
    submit: '提交',
    currentUser: '当前用户',
    loadFailed: '加载笔记详情失败',
    loadCommentsFailed: '加载评论失败',
    likeSuccess: '点赞成功',
    unlikeSuccess: '取消点赞',
    collectSuccess: '收藏成功',
    uncollectSuccess: '取消收藏',
    followSuccess: '关注成功',
    unfollowSuccess: '取消关注',
    shareDev: '分享功能开发中',
    selectReward: '请选择打赏金额',
    insufficientCoins: '汉币余额不足',
    rewardSuccess: '成功打赏 {n} 枚汉币',
    rewardFailed: '打赏失败',
    enterComment: '请输入评论内容',
    commentSuccess: '评论发表成功',
    commentFailed: '评论发表失败',
    enterReply: '请输入回复内容',
    replySuccess: '回复发表成功',
    replyFailed: '回复发表失败',
    selectReasonPrompt: '请选择举报原因',
    reportSubmitted: '举报已提交，我们会尽快处理',
    reportFailed: '举报提交失败'
  },
  characterDetail: {
    commonChar: '常用字',
    traditionalChar: '繁体字',
    basicInfo: '基本信息',
    radical: '部首',
    strokeCount: '笔画数',
    wuxing: '五行属性',
    structure: '结构',
    strokeAnimation: '笔顺动画',
    play: '播放',
    reset: '重置',
    totalStrokes: '总笔画数：{n}画',
    writingTips: '书写要点：{tips}',
    pronunciation: '发音',
    playPronunciation: '播放发音',
    polyphonic: '多音字信息',
    etymology: '字源演变',
    etymologyAnalysis: '字源解析',
    shuowen: '说文解字',
    original: '原文',
    translation: '白话翻译',
    wordsIdioms: '词语成语',
    commonWords: '常用词语',
    relatedIdioms: '相关成语',
    communityContent: '社区内容',
    hot: '最热',
    new: '最新',
    noStories: '还没有人分享关于这个字的故事呢',
    shareFirstStory: '快来分享第一个故事',
    loadFailed: '加载字符详情失败',
    loadNotesFailed: '加载笔记失败',
    playing: '笔顺动画播放中...',
    resetDone: '动画已重置',
    playingSound: '正在播放发音...'
  },
  publishNote: {
    title: '发布笔记',
    titlePlaceholder: '请输入笔记标题',
    contentPlaceholder: '分享你关于汉字的故事、冷知识或记忆方法...',
    mediaLabel: '添加图片/视频',
    uploadText: '点击上传媒体文件',
    uploadHint: '支持图片和视频，最长60秒',
    linkCharacter: '关联汉字',
    searchCharacterPlaceholder: '搜索并选择汉字',
    topicLabel: '话题标签',
    searchTopicPlaceholder: '搜索或创建话题',
    newTopicPlaceholder: '输入新话题名称',
    create: '创建',
    createNewTopic: '+ 创建新话题',
    aiPolish: '启用AI润色 (让内容更精彩)',
    aiHint: 'AI会帮您优化文字表达，使内容更生动有趣',
    enterTitle: '请输入笔记标题',
    titleTooLong: '标题长度不能超过50个字符',
    enterContent: '请输入笔记内容',
    contentTooShort: '内容至少需要10个字符',
    selectCharacter: '请至少关联一个汉字',
    imageVideoOnly: '只支持图片和视频文件',
    fileTooLarge: '文件大小不能超过10MB',
    uploadSuccess: '文件上传成功',
    enterTopicName: '请输入话题名称',
    topicExists: '该话题已添加',
    topicCreated: '话题创建成功',
    topicCreateFailed: '话题创建失败',
    publishSuccess: '笔记发布成功！',
    publishFailed: '发布失败，请重试'
  },
  wordBook: {
    title: '我的生词本',
    totalWords: '生词总数',
    todayAdded: '今日添加',
    toReview: '待复习',
    addWord: '添加生词',
    startReview: '开始复习',
    wordList: '生词列表',
    searchPlaceholder: '搜索生词',
    sortByTime: '按添加时间',
    sortByAlpha: '按字母顺序',
    emptyDesc: '生词本还是空的，快去添加一些生词吧！',
    addWords: '添加生词',
    basicInfo: '基本信息',
    pinyin: '拼音',
    radical: '部首',
    strokeCount: '笔画数',
    meaning: '释义',
    examples: '例句',
    removeWord: '移除生词',
    viewDetail: '查看详细',
    reviewDev: '复习功能开发中',
    removeConfirm: '确定要将这个生词从生词本中移除吗？',
    removeSuccess: '已移除生词',
    removeFailed: '移除失败'
  },
  profile: {
    title: '个人主页',
    editProfile: '编辑资料',
    follow: '关注',
    following: '已关注',
    badges: '我的徽章',
    publishedNotes: '发布的笔记',
    collectedNotes: '收藏的笔记',
    followingTab: '关注',
    followersTab: '粉丝',
    wordBookTab: '生词本',
    noPublishedNotes: '还没有发布过笔记',
    noCollectedNotes: '还没有收藏过笔记',
    noFollowing: '还没有关注任何人',
    noFollowers: '还没有粉丝',
    wordBookEmpty: '生词本还是空的',
    goAddWord: '去添加生词',
    addedAt: '添加于 {n}',
    noBio: '这个用户很懒，什么都没写',
    loadProfileFailed: '加载个人主页失败',
    loadUserProfileFailed: '加载用户主页失败',
    loadNotesFailed: '加载笔记失败',
    editDev: '编辑资料功能开发中',
    likes: '获赞',
    coins: '汉币',
    user: '用户'
  },
  adminLogin: {
    title: '汉字社区 · 管理后台',
    subtitle: '管理用户、内容与系统设置，守护社区秩序',
    featureUserTitle: '用户管理',
    featureUserDesc: '管理注册用户，分配角色与权限',
    featureContentTitle: '内容审核',
    featureContentDesc: '审核笔记、评论，维护优质内容',
    featureConfigTitle: '系统配置',
    featureConfigDesc: '灵活配置站点参数与运营策略',
    copyright: '汉字社区 © 2026',
    adminLoginTitle: '管理员登录',
    registerTitle: '注册新账号',
    loginSubtitle: '使用管理员邮箱登录以管理社区',
    registerSubtitle: '申请管理员账号以使用后台管理功能',
    adminOnly: '仅限已有管理员账号登录',
    emailPlaceholder: '管理员邮箱',
    passwordPlaceholder: '密码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    contactSuperAdmin: '请联系超级管理员重置密码',
    login: '登录',
    enterEmail: '请输入管理员邮箱',
    validEmail: '请输入正确的邮箱格式',
    enterPassword: '请输入密码',
    passwordMin: '密码长度至少8位',
    loginFailed: '登录失败'
  },
  adminLayout: {
    brand: '汉字社区',
    searchPlaceholder: '搜索菜单、用户、内容...',
    notifications: '通知',
    profileSettings: '个人设置',
    systemSettings: '系统设置',
    backToFront: '返回前台',
    logout: '退出登录',
    dashboard: '控制台',
    users: '用户管理',
    roles: '角色管理',
    permissions: '权限管理',
    texts: '内容管理',
    settings: '系统设置',
    profileDev: '个人设置页面开发中',
    logoutConfirm: '确定要退出登录吗？',
    logoutConfirmTitle: '确认',
    logoutBtn: '退出'
  },
  dashboard: {
    recentActivity: '近期动态',
    quickActions: '快捷操作',
    addUser: '添加用户',
    addUserDesc: '创建新用户账号',
    roleMgmt: '角色管理',
    roleMgmtDesc: '配置用户角色与权限',
    contentMgmt: '内容管理',
    contentMgmtDesc: '管理笔记与评论内容',
    systemSettings: '系统设置',
    systemSettingsDesc: '查看与修改系统配置',
    totalUsers: '用户总数',
    activeUsers: '活跃用户',
    totalPosts: '内容总数',
    totalComments: '评论总数',
    coinCirculation: '汉币流通'
  },
  users: {
    searchPlaceholder: '搜索用户名或邮箱...',
    addUser: '添加用户',
    username: '用户名',
    email: '邮箱',
    role: '角色',
    admin: '管理员',
    moderator: '审核员',
    user: '用户',
    status: '状态',
    active: '正常',
    inactive: '已禁用',
    createdAt: '注册时间',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    nameLabel: '姓名',
    namePlaceholder: '请输入姓名',
    roleLabel: '角色',
    selectRole: '请选择角色',
    statusLabel: '状态',
    selectStatus: '请选择状态',
    addTitle: '添加用户',
    editTitle: '编辑用户',
    deleteConfirm: '确定要删除用户「{name}」吗？此操作不可撤销。',
    deleteConfirmTitle: '确认删除',
    deleteSuccess: '用户已删除',
    updatedSuccess: '用户已更新',
    createdSuccess: '用户已创建',
    initialPassword: '新用户初始密码：{pwd}',
    createSuccessTitle: '创建成功',
    gotIt: '知道了',
    enterName: '请输入姓名',
    enterEmail: '请输入邮箱',
    validEmail: '请输入正确的邮箱格式',
    selectRoleRequired: '请选择角色',
    selectStatusRequired: '请选择状态'
  },
  roles: {
    searchPlaceholder: '搜索角色名称...',
    addRole: '添加角色',
    name: '角色名称',
    code: '角色标识',
    description: '描述',
    status: '状态',
    enabled: '启用',
    disabled: '停用',
    actions: '操作',
    edit: '编辑',
    permissions: '权限',
    delete: '删除',
    nameLabel: '名称',
    namePlaceholder: '请输入角色名称',
    codeLabel: '标识',
    codePlaceholder: '例如：admin, editor',
    descLabel: '描述',
    descPlaceholder: '角色描述',
    statusLabel: '状态',
    permDialogTitle: '分配权限',
    addTitle: '添加角色',
    editTitle: '编辑角色',
    deleteConfirm: '确定要删除角色「{name}」吗？',
    deleteSuccess: '角色已删除',
    saveSuccess: '保存成功',
    permsUpdated: '权限已更新',
    enterName: '请输入角色名称',
    enterCode: '请输入角色标识',
    selectStatus: '请选择状态'
  },
  permissions: {
    title: '权限列表',
    addPerm: '添加权限',
    name: '权限名称',
    code: '权限标识',
    type: '类型',
    menu: '菜单',
    button: '按钮',
    api: '接口',
    path: '路径',
    sort: '排序',
    status: '状态',
    enabled: '启用',
    disabled: '停用',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    parentPerm: '父级权限',
    selectParent: '选择父级（可选）',
    nameLabel: '名称',
    namePlaceholder: '请输入权限名称',
    codeLabel: '标识',
    codePlaceholder: '例如：user:create',
    typeLabel: '类型',
    sortLabel: '排序',
    pathLabel: '路径',
    statusLabel: '状态',
    addTitle: '添加权限',
    editTitle: '编辑权限',
    deleteConfirm: '确定要删除权限「{name}」吗？',
    deleteConfirmTitle: '确认删除',
    deleteSuccess: '已删除',
    saveSuccess: '保存成功',
    enterName: '请输入权限名称',
    enterCode: '请输入权限标识',
    selectType: '请选择类型',
    selectStatus: '请选择状态'
  },
  settings: {
    general: '基本设置',
    siteName: '站点名称',
    siteUrl: '站点地址',
    adminEmail: '管理员邮箱',
    timezone: '时区',
    save: '保存设置',
    reset: '重置',
    security: '安全设置',
    twoFactor: '启用双因素认证',
    sessionTimeout: '会话超时时间（分钟）',
    passwordMinLen: '密码最小长度',
    forcePwdChange: '强制定期修改密码',
    notifications: '通知设置',
    emailNotif: '邮件通知',
    smsNotif: '短信通知',
    pushNotif: '推送通知',
    notifEmail: '通知邮箱',
    generalSaved: '基本设置已保存',
    securitySaved: '安全设置已保存',
    notifSaved: '通知设置已保存',
    saveFailed: '保存失败'
  },
  textManagement: {
    searchPlaceholder: '搜索标题或内容...',
    allStatus: '全部状态',
    published: '已发布',
    draft: '草稿',
    deleted: '已删除',
    title: '标题',
    author: '作者',
    likes: '点赞',
    comments: '评论',
    createdAt: '创建时间',
    status: '状态',
    actions: '操作',
    preview: '预览',
    publish: '发布',
    offline: '下线',
    delete: '删除',
    previewTitle: '内容预览',
    loadFailed: '加载内容列表失败',
    confirmTitle: '确认操作',
    statusConfirm: '确定要{action}「{title}」吗？',
    statusSuccess: '已{action}',
    statusFailed: '{action}失败',
    deleteConfirm: '确定要删除「{title}」吗？此操作不可恢复。',
    deleteConfirmTitle: '确认删除',
    deleteSuccess: '已删除'
  }
}